import React, { useState } from 'react';

const RestDaysPreference = ({ onPreferenceChange }) => {
    const [weekendPreference, setWeekendPreference] = useState('');
    const [selectedDays, setSelectedDays] = useState([]);

    const daysOfWeek = [
        { id: 'monday', label: 'Monday' },
        { id: 'tuesday', label: 'Tuesday' },
        { id: 'wednesday', label: 'Wednesday' },
        { id: 'thursday', label: 'Thursday' },
        { id: 'friday', label: 'Friday' },
        { id: 'saturday', label: 'Saturday' },
        { id: 'sunday', label: 'Sunday' }
    ];

    const handleWeekendPreferenceChange = (preference) => {
        setWeekendPreference(preference);
        // Reset selected days when weekend preference changes
        setSelectedDays([]);

        onPreferenceChange({
            weekendPreference: preference,
            selectedDays: []
        });
    };

    const handleDayToggle = (day) => {
        setSelectedDays(prev => {
            const newSelection = prev.includes(day)
                ? prev.filter(d => d !== day)
                : [...prev, day];

            onPreferenceChange({
                weekendPreference,
                selectedDays: newSelection
            });

            return newSelection;
        });
    };

    return (
        <div className="w-full max-w-md bg-white rounded-lg shadow-sm border border-gray-200">
            <div className="p-6">
                <h2 className="text-lg font-medium mb-4">Study Schedule Preferences</h2>

                <div className="space-y-6">
                    <div className="space-y-4">
                        <h3 className="text-sm font-medium">Weekend Preference</h3>
                        <div className="space-y-2">
                            <label className="flex items-center space-x-2 cursor-pointer">
                                <input
                                    type="radio"
                                    name="weekendPreference"
                                    value="minimizeWeekends"
                                    checked={weekendPreference === 'minimizeWeekends'}
                                    onChange={(e) => handleWeekendPreferenceChange(e.target.value)}
                                    className="h-4 w-4"
                                />
                                <span className="text-sm">Minimize weekend study time</span>
                            </label>
                            <label className="flex items-center space-x-2 cursor-pointer">
                                <input
                                    type="radio"
                                    name="weekendPreference"
                                    value="customDays"
                                    checked={weekendPreference === 'customDays'}
                                    onChange={(e) => handleWeekendPreferenceChange(e.target.value)}
                                    className="h-4 w-4"
                                />
                                <span className="text-sm">Select custom rest days</span>
                            </label>
                        </div>
                    </div>

                    {weekendPreference === 'customDays' && (
                        <div className="space-y-4">
                            <h3 className="text-sm font-medium">Select Rest Days</h3>
                            <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 md:grid-cols-3">
                                {daysOfWeek.map(day => (
                                    <label
                                        key={day.id}
                                        className="flex items-center space-x-2 p-2 border rounded hover:bg-gray-50 cursor-pointer"
                                    >
                                        <input
                                            type="checkbox"
                                            checked={selectedDays.includes(day.id)}
                                            onChange={() => handleDayToggle(day.id)}
                                            className="h-4 w-4"
                                        />
                                        <span className="text-sm">{day.label}</span>
                                    </label>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default RestDaysPreference;